import React from 'react';
import { Editor } from '@tinymce/tinymce-react';
import MethodsOneContext from './../Contexts/MethodsOne';
import MethodsTwoContext from './../Contexts/MethodsTwo';
import axios from './../Api/MainApi';
import  {requaredValid, onlyLettersValid, emailValid, finalizeValid} from './../Tools/Validation';

const ImageThumb = ({ name, url }) => {
  return <img src={url} style={{ width: '235px', height: '165px' }} class="rounded-lg" alt={name} />;
};

// const ImageThumb = ({ image }) => {
//   return <img src={URL.createObjectURL(image)} style={{ width: '200px', height: '200px' }} alt={image.name} />;
// };

class App extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      pageId: 0,
      file: "",
      content: "",
      ImageUrl: "",
      PageUrl: "",
      TitleOne: "",
      TitleTwo: "",
      Active:'false',
      topics: [],
      errors: {}
    };

  }

  state = {
    pageId: 0,
    file: "",
    content: "",
    ImageUrl: "",
    PageUrl: "",
    TitleOne: "",
    TitleTwo: "",
    Active:'false',
    topics: [],
    errors: {}
  };

  static contextType = MethodsTwoContext;

  handleUpload = (event) => {
    this.setState({ file: event.target.files[0] });
    const formData = new FormData();
    formData.append('body', event.target.files[0]);
    axios.post(`rest/Uploadfile`,
      formData,
      {
        headers: {
          Authorization: this.context.authorizationInfo.state.accessToken
        },

      })
      .then(Response => {
        var imagePath = '';
        if (this.state.file.name) {
          imagePath = 'http://cdn.bitkala.ir/' + this.state.file.name;
        }
        console.log(' عکسآدرسه', imagePath)
        // this.state.ImageUrl = imagePath;
        this.setState({ ImageUrl: imagePath });
      })
      .catch(err => {
        console.log(err)
      })
  }

  example_image_upload_handler = (blobInfo, success, failure, progress) => {

    console.log('hi amin joon');
    const formData = new FormData();
    formData.append('file', blobInfo.blob(), blobInfo.filename());
    axios.post(`rest/Uploadfile`,
      formData,
      {
        headers: {
          Authorization: this.context.authorizationInfo.state.accessToken
        },

      })
      .then(Response => {
        success(blobInfo.filename());
      })
      .catch(err => {
        failure('AinError: ', { remove: true });
        console.log(err)
      })
  };


  deleteTopic = () => {
    var r = window.confirm("آیا مطمعن به حذف هستین؟" + "(" + this.state.TitleOne + ")");
    if (r == true) {
      axios.post(`rest/deleteArticle`,
        { PageId: this.state.pageId },
        {
          headers: {
            Authorization: this.context.authorizationInfo.state.accessToken
          },

        })
        .then(Response => {
          this.getAllTopics();
          this.clearData();
          alert("با موفقیت حذف شد");
        })
        .catch(err => {
          alert(" حذف نشد");
          console.log(err)
        })
    } else {

    }

  }

  saveTopic = () => {

    if(this.handleValidation()){
        axios.post(`rest/AddTopicAndPageContent`,
          {
            PageId: this.state.pageId,
            Value: this.state.content,
            ImageUrl: this.state.ImageUrl,
            TitleOne: this.state.TitleOne,
            TitleTwo: this.state.TitleTwo,
            PageUrl: this.state.PageUrl,
            Active : this.state.Active
          },
          {
            headers: {
              Authorization: this.context.authorizationInfo.state.accessToken
            },
          })
          .then(Response => {
            console.log('javabe akhar', Response.data);
            this.state.pageId = Response.data;
            if (Response.data > 0) {
              this.getAllTopics();
              this.clearData();
              alert("با موفقیت ذخیره شد");
            }
            else {
              alert("ذخیره نشد");
            }
          })
          .catch(err => {
            alert("ذخیره نشد");
            console.log(err)
          })
    }
    else {
      //bikhodi vase in ke setstate faal beshe
     this.setState({errors:this.state.errors});
    }
  }

  clearData = () => {
    this.setState({
      file: "",
      pageId: 0,
      content: "",
      ImageUrl: "",
      PageUrl: "",
      TitleOne: "",
      TitleTwo: "",
      Active:'false',
      errors: {}
    }); 
  }


  handleEditorChange = (content, editor) => {
    this.state.content = content;
  }

  onDropdownSelected = (e) => {
    this.state.pageId = e.target.value;
    this.getDataTopic(this.state.pageId);
  }

  componentDidMount() {
    this.getAllTopics();
  }

  getDataTopic = (pageId) => {
    var self = this;
    axios.post(`rest/getDataTopic`,
      { PageId: pageId },
      {
        headers: {
          Authorization: this.context.authorizationInfo.state.accessToken
        },

      })
      .then(Response => {
        self.setState({
          file: { name: Response.data.imageUrl },
          content: Response.data.value,
          ImageUrl: Response.data.imageUrl,
          PageUrl: Response.data.pageUrl,
          TitleOne: Response.data.titleOne,
          TitleTwo: Response.data.titleTwo,
          Active: Response.data.active.toString()
        });
      })
      .catch(err => {
        console.log(err)
      })
  }

  getAllTopics() {
    axios.get(`rest/GetAllTopic`,
      {
        headers: {
          Authorization: this.context.authorizationInfo.state.accessToken
        },

      })
      .then(Response => {
        this.setState({ topics: Response.data });
      })
      .catch(err => {
        console.log(err)
      })
  }

  onInputchange = (event) => {
    event.target.value  = event.target.type == 'checkbox' ?  !(this.state.Active == 'true') : event.target.value ;
    this.state[event.target.name]=event.target.value;
    this.setState({
      [event.target.name]: event.target.value
    });
    this.handleValidation(event.target.name);
  }


  handleValidation(realTimeName){

    requaredValid(this.state,"PageUrl",realTimeName);
    requaredValid(this.state,"TitleOne",realTimeName);
    // onlyLettersValid(this,"PageUrl",realTimeName);
    // emailValid(this,"TitleOne",realTimeName);

  return finalizeValid(this.state.errors);
}

  render() {
    const file = this.state.file;
    return (
      <>
        <div>
          <form class="space-y-3 bg-white border border-solid border-gray-200 rounded-lg p-5">
            <div class="flex justify-start items-center space-x-6 space-x-reverse">
              <button type="button" onClick={this.clearData} class="bg-blue-500 hover:bg-blue-400 text-white p-2 px-6 font-medium rounded hover:text-white">
                <span>جدید</span>
              </button>
              <button type="button" onClick={this.saveTopic} class="bg-green-600 hover:bg-green-500 text-white p-2 px-6 font-medium rounded hover:text-white">
                <span>ذخیره</span>
              </button>
              <button type="button" onClick={this.deleteTopic} class="bg-red-600 hover:bg-red-400 text-white p-2 px-6 font-medium rounded hover:text-white">
                <span>حذف</span>
              </button>
              {/* <div class=''>       
                <label htmlFor='ch1' class='ml-2 mr-8 mb-3'>نشان داده شود</label>
                <input type='checkbox' class=' h-4 w-4' defaultChecked={this.state.Active} id='ch1' onChange={this.onInputchange}/>
              </div> */}
              <div data-v-0f3f40df="" class="markdown-preview-switch">
                <label data-v-0f3f40df="" class="switch">
                  <input data-v-0f3f40df="" type="checkbox" name='Active' checked={(this.state.Active == 'true')} onChange={this.onInputchange}/>
                  <span data-v-0f3f40df="" class="slider round">
                  </span></label>
                <span data-v-0f3f40df=""  class="markdown-preview-switch__text">این مقاله نشان داده شود</span>
              </div>
            </div>
            <div class="space-y-2">
              <label class="font-bold text-gray-600">موضوعات</label>
                <select type="select" value={this.state.pageId} onChange={this.onDropdownSelected} class="p-3 px-4  font-black border border-solid border-gray-200 rounded w-full focus:ring-1 focus:ring-gray-200  " placeholder="لطفا ایمیل خود را وارد کنید" >
                  {this.state.topics.map((e, key) => {
                    return <option key={key} value={e.value}>{e.name}</option>;
                  })}
                </select>
            </div>
            <div class="flex space-x-2 space-x-reverse">
              <div class="space-y-2 flex-1 relative">
                <label class="font-bold text-gray-600">آدرس صفحه</label>
                <input type="text" value={this.state.PageUrl} name='PageUrl' onChange={this.onInputchange} class="p-3 px-4 border border-solid border-gray-200 rounded w-full focus:ring-1 focus:ring-gray-200  " placeholder="لطفا آدرس صفحه را وارد کنید" />
                <div><span class="text-red-600 mr-2">{this.state.errors["PageUrl"]}</span></div>
              </div>
              <div class="space-y-2 flex-1 relative">
                <label class="font-bold text-gray-600">عنوان </label>
                <input type="text" value={this.state.TitleOne} name='TitleOne' onChange={this.onInputchange} class="p-3 px-4 border border-solid border-gray-200 rounded w-full focus:ring-1 focus:ring-gray-200  " placeholder="لطفا عنوان را وارد کنید" />
                <div><span class="text-red-600 mr-2">{this.state.errors["TitleOne"]}</span></div>
              </div>
            </div>
            <div class="flex space-x-4 space-x-reverse">
              <div class="space-y-2 flex-1 relative">
                <label class="font-bold text-gray-600">توضیح مقاله</label>
                <div>
                  <textarea onChange={this.onInputchange} value={this.state.TitleTwo} name='TitleTwo' placeholder="لطفا توضیحات خود را وارد کنید" rows="10" class="p-3 px-4 border border-solid border-gray-200 rounded w-full focus:ring-1 focus:ring-gray-200  "></textarea>
                </div>
              </div>
              <div class="space-y-2 relative pt-6 ">
                {file && <ImageThumb name={this.state.file.name} url={this.state.ImageUrl} />}
              </div>
            </div>
            <div class="space-y-2">
              <label class="font-bold text-gray-600">تصویر مقاله</label>
              <input type="file" value="" onChange={this.handleUpload} class="p-3 px-4 border border-solid border-gray-200 rounded w-full focus:ring-1 focus:ring-gray-200  " placeholder="لطفا ایمیل خود را وارد کنید" />
            </div>
            <div class="space-y-3">
              <label class="font-bold text-gray-600">محتوای صفحه</label>
              <div class="border border-solid border-gray- border-gray-300 rounded ">
                <Editor
                  initialValue=""
                  value={this.state.content}
                  init={{
                    height: 800,
                    selector: "textarea",
                    images_upload_handler: this.example_image_upload_handler,
                    // images_upload_url: 'postAcceptor.php',
                    //images_upload_base_path: 'cdn.bitkala.ir',
                    document_base_url: 'http://cdn.bitkala.ir/',
                    relative_urls: false,
                    remove_script_host: false,
                    convert_urls: true,
                    //   plugins: "emoticons hr image link lists charmap table directionality", 
                    directionality: "rtl",
                    plugins: [
                      'advlist autolink link image lists charmap print preview hr anchor pagebreak',
                      'searchreplace wordcount visualblocks visualchars code fullscreen insertdatetime media nonbreaking',
                      'table emoticons template paste help'
                    ],
                    toolbar: 'undo redo |table| styleselect | fontselect fontsizeselect formatselect| bold italic | alignleft aligncenter alignright alignjustify | ' +
                      'bullist numlist outdent indent | link image | print preview media fullpage | ' +
                      'forecolor backcolor emoticons | help',
                    menu: {
                      favs: { title: 'My Favorites', items: 'code visualaid | searchreplace | emoticons' }
                    },
                    menubar: 'favs file edit view insert format tools table help',
                    skin: 'outside',
                    // height: 500,
                    // selector: 'textarea#full-featured',
                    // plugins: 'print preview powerpaste casechange importcss tinydrive searchreplace autolink autosave save directionality advcode visualblocks visualchars fullscreen image link media mediaembed template codesample table charmap hr pagebreak nonbreaking anchor toc insertdatetime advlist lists checklist wordcount tinymcespellchecker a11ychecker imagetools textpattern noneditable help formatpainter permanentpen pageembed charmap tinycomments mentions quickbars linkchecker emoticons advtable',
                    // tinydrive_token_provider: 'URL_TO_YOUR_TOKEN_PROVIDER',
                    // tinydrive_dropbox_app_key: 'YOUR_DROPBOX_APP_KEY',
                    // tinydrive_google_drive_key: 'YOUR_GOOGLE_DRIVE_KEY',
                    // tinydrive_google_drive_client_id: 'YOUR_GOOGLE_DRIVE_CLIENT_ID',
                    // mobile: {
                    //     plugins: 'print preview powerpaste casechange importcss tinydrive searchreplace autolink autosave save directionality advcode visualblocks visualchars fullscreen image link media mediaembed template codesample table charmap hr pagebreak nonbreaking anchor toc insertdatetime advlist lists checklist wordcount tinymcespellchecker a11ychecker textpattern noneditable help formatpainter pageembed charmap mentions quickbars linkchecker emoticons advtable'
                    // },
                    // menu: {
                    //     tc: {
                    //     title: 'TinyComments',
                    //     items: 'addcomment showcomments deleteallconversations'
                    //     }
                    // },
                    // menubar: 'file edit view insert format tools table tc help',
                    // toolbar: 'undo redo | bold italic underline strikethrough | fontselect fontsizeselect formatselect | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist checklist | forecolor backcolor casechange permanentpen formatpainter removeformat | pagebreak | charmap emoticons | fullscreen  preview save print | insertfile image media pageembed template link anchor codesample | a11ycheck ltr rtl | showcomments addcomment',
                    // autosave_ask_before_unload: true,
                    // autosave_interval: '30s',
                    // autosave_prefix: '{path}{query}-{id}-',
                    // autosave_restore_when_empty: false,
                    // autosave_retention: '2m',
                    // image_advtab: true,
                    // link_list: [
                    //     { title: 'My page 1', value: 'https://www.tiny.cloud' },
                    //     { title: 'My page 2', value: 'http://www.moxiecode.com' }
                    // ],
                    // image_list: [
                    //     { title: 'My page 1', value: 'https://www.tiny.cloud' },
                    //     { title: 'My page 2', value: 'http://www.moxiecode.com' }
                    // ],
                    // image_class_list: [
                    //     { title: 'None', value: '' },
                    //     { title: 'Some class', value: 'class-name' }
                    // ],
                    // importcss_append: true,
                    // templates: [
                    //         { title: 'New Table', description: 'creates a new table', content: '<div class="mceTmpl"><table width="98%%"  border="0" cellspacing="0" cellpadding="0"><tr><th scope="col"> </th><th scope="col"> </th></tr><tr><td> </td><td> </td></tr></table></div>' },
                    //     { title: 'Starting my story', description: 'A cure for writers block', content: 'Once upon a time...' },
                    //     { title: 'New list with dates', description: 'New List with dates', content: '<div class="mceTmpl"><span class="cdate">cdate</span><br /><span class="mdate">mdate</span><h2>My List</h2><ul><li></li><li></li></ul></div>' }
                    // ],
                    // directionality :"rtl",
                    // template_cdate_format: '[Date Created (CDATE): %m/%d/%Y : %H:%M:%S]',
                    // template_mdate_format: '[Date Modified (MDATE): %m/%d/%Y : %H:%M:%S]',
                    // image_caption: true,
                    // quickbars_selection_toolbar: 'bold italic | quicklink h2 h3 blockquote quickimage quicktable',
                    // noneditable_noneditable_class: 'mceNonEditable',
                    // toolbar_mode: 'sliding',
                    // spellchecker_ignore_list: ['Ephox', 'Moxiecode'],
                    // tinycomments_mode: 'embedded',
                    // content_style: '.mymention{ color: gray; }',
                    // contextmenu: 'link image imagetools table configurepermanentpen',
                    // a11y_advanced_options: true,
                    // skin: useDarkMode ? 'oxide-dark' : 'oxide',
                    // content_css: useDarkMode ? 'dark' : 'default',
                  }}
                  onEditorChange={this.handleEditorChange}
                />
              </div>
            </div>
            <div class="flex justify-start items-center space-x-6 space-x-reverse">
              <button type="button" onClick={this.saveTopic} class="bg-green-600 hover:bg-green-500 text-white p-2 px-6 font-medium rounded hover:text-white">
                <span>ذخیره</span>
              </button>
              <button type="button" onClick={this.deleteTopic} class="bg-red-600 hover:bg-red-400 text-white p-2 px-6 font-medium rounded hover:text-white">
                <span>حذف</span>
              </button>
            </div>
          </form>   
        </div>

      </>
    );
  }
}

export default App;